<app-payment-detail-cont
  [isMobile]="isMobile"
  [isModal]="isModal"
  [showSwipeUp]="showSwipeUp"
  [total]="price?.Total"
  [currencyCode]="price?.CurrencyCode"
  [conversionRate]="conversionRate"
  [isLoading]="!price"
  [showInfo]="isMobile"
  [discount]="discount$ | async"
  [rows]="rows"
  [subtitles]="[
    {
      Label: 'PACKAGES_MODULES.PACKAGE_BOOKING.PAYMENT_DETAIL.PRICE_TO_PACKAGE.PACKAGE_TO' | transloco,
      Description: descriptionsTranslate
    }
  ]"
  (toggleShowSwipeUp)="toggleShowSwipeUp.emit()">
  <ng-container cashbackContent>
    <app-benefit-cashback
      [totalPrice]="price?.Total"
      [currencyCode]="price?.CurrencyCode"
      [productReference]="productReference">
    </app-benefit-cashback>
  </ng-container>
</app-payment-detail-cont>